var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[(_vm.isCollapse)?_c('el-aside',{attrs:{"width":"256px"}},[_c('Menu')],1):_vm._e(),_c('el-container',[_c('el-header',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isShow),expression:"!isShow"}]},[_c('Header')],1),_c('el-container',[_c('el-main',[_c('Main')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }